import { designationActionType } from '../../constants/index';

export default (state = {}, action) => {
    switch (action.type) {
        case designationActionType.FETCH_DESIGNATIONS_ALL:
            return {
                ...state,
                "designationsAll": action.payload
            };
        case designationActionType.FETCH_DESIGNATIONS_SUCCESS:
            return {
                ...state,
                "designationsClassAPISuccess": action.payload
            };
        default:
            return state;
    }
};
